// ------------------------------------------------------------
import { ReactNode, CSSProperties } from 'react';
import { grey50 } from '@Utils/Colors';
// ------------------------------------------------------------
interface ToolbarProps {
    title?: ReactNode;
    style?: CSSProperties;
    rightItems?: ReactNode[];
}
// ------------------------------------------------------------
export default function Toolbar(props: ToolbarProps) {
    return <div style={{
        height: 40,
        fontSize: 16,
        padding: '0 10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: grey50,
        backgroundColor: '#134459',
        ...props.style
    }}>
        <div>{props.title}</div>
        <div style={{
            display: 'inline-flex',
            alignItems: 'center'
        }}>
            {props.rightItems}
        </div>
    </div>;
}
// ------------------------------------------------------------